import { useGetMemberLectureTotalCount } from '#api/member';
import {
  Container3,
  Divider,
  LectureText,
  Number,
  TextContainer
} from './styles';

interface LectureCountProps {}

const LectureCount = ({}: LectureCountProps) => {
  const personId = sessionStorage.getItem('personId');
  const { data } = useGetMemberLectureTotalCount(personId || '');

  if (!data) return null;

  return (
    <Container3>
      <TextContainer>
        <LectureText>총 신청 회차</LectureText>
        <Number>{data.totalRegisteredCount}</Number>
        <Divider />
      </TextContainer>
      <TextContainer>
        <LectureText>완료 회차</LectureText>
        <Number>{data.completedRegisteredCount}</Number>
        <Divider />
      </TextContainer>
      <TextContainer>
        <LectureText>차트 작성 수</LectureText>
        <Number>{data.chartCreationCount}</Number>
      </TextContainer>
    </Container3>
  );
};

export default LectureCount;
